<ul class="page-tabs">
  @for (tab of tabs; track $index) {
  <li
    (mouseenter)="onTabHover($index)"
    (click)="setActiveTab($index)"
    [ngClass]="{ active: tab.label === activeTab }"
  >
    <span>{{ tab.label }}</span>
  </li>
  }

  <li class="fill"></li>
</ul>

<div class="tab-content" #tabContent>
  <ng-content></ng-content>
</div>
